<template>
    <div class="base-login-phone" :class="{'loginphone-sp': $store.state.screen == 1}">
        <img class="logo" src="~images/logo_min.png" />
        <input class="value" onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}" onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}" type="text" maxlength="11" placeholder="请输入手机号" v-model="phone" />
        <div class="val-box">
            <input class="phonecode" type="text" maxlength="6" placeholder="请输入验证码" v-model="pwd" />
            <div class="code" @click="getCode" v-if="iscode == false">获取验证码</div>
            <div class="code" v-if="iscode == true">{{count}}s</div>
        </div>
        <div class="btn-login" @click="onLogin">立即登录</div>
        <div class="footer">
            <div class="item" @click="onPwd">密码登录</div>
            <div class="item" @click="$router.push('/base-register')">注册账号</div>
            <div class="item" @click="$router.push('/base-forget-pwd')">忘记密码</div>
        </div>
        <transition name="component-fade" mode="out-in">
            <TheTips :msg='msg' v-if="msg" />
        </transition>
    </div>
</template>

<script>
    import TheTips from '@/components/TheTips'

    export default {
        components: {
            TheTips
        },
        data () {
            return {
                msg: null,
                phone: '',
                pwd: '',
                iscode: false,
                count: 59,
                loginData: {}
            }
        },
        methods: {
            // 获取验证码
            getCode () {
                if (this.iscode == true) {
                    return false
                }
                let reg = /^1[0-9]{10}$/
                if (!reg.test(this.phone)) {
                    this.msg = '手机号格式不正确'
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                    return false
                }
                if (this.phone.length == 11 && reg.test(this.phone)) {
                    let options = {
                        appid: this.loginData.appid, //应用ID
                        mobile: this.phone,
                        type: 5 //1 注册 2绑定 3解绑 4 找回密码 5 登录
                    };
                    options.sign = this.util.getSign(options, this.loginData.appkey);
                    this.$axios.post('http://sdk.gameschain.pro/index.php?g=api&m=user&a=send_message', this.$qs.stringify(options)).then(res => {
                        if (res.data.status == 1) {
                            this.iscode = true
                            this.count = 59
                            let time = setInterval(() => {
                                this.count--
                                if (this.count == 0) {
                                    clearInterval(time)
                                    this.iscode = false
                                }
                            }, 1000)

                            this.msg = '验证码已发送'
                            setTimeout(() => {
                                this.msg = null
                            }, 1000)
                        } else {
                            this.msg = res.data.msg
                            setTimeout(() => {
                                this.msg = null
                            }, 2000)
                        }
                    }).
                    catch(o => {
                        this.msg = '请求失败'
                        setTimeout(() => {
                            this.msg = null
                        }, 2000)
                    })
                } else {
                    this.msg = '手机号格式不正确'
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                }
            },
            // 手机号登录
            onLogin () {
                let reg = /^1[0-9]{10}$/
                if (!reg.test(this.phone)) {
                    this.msg = '手机号格式不正确'
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                    return false
                }
                if (this.phone.replace(/\s*/g, "") && this.pwd.replace(/\s*/g, "")) {
                    let options = {
                        mobile: this.phone,
                        code: this.pwd,
                        appid: this.loginData.appid, //应用ID
                        channel: this.loginData.channel, //渠道ID
                        system: this.loginData.system, //系统
                        machine_code: this.loginData.machine_code, //设备号
                        ext:'1-0'
                    };
                    options.sign = this.util.getSign(options, this.loginData.appkey);
                    this.$axios.post('http://sdk.gameschain.pro/index.php?g=api&m=user&a=login_by_mobile_code', this.$qs.stringify(options)).then(res => {
                        if (res.data.status == 1) {
                            sessionStorage.setItem('userData', JSON.stringify(res.data))
                            if (this.loginData.system == 2) {
                                localStorage.removeItem('iosUser')
                            }
                            this.msg = '登录成功'
                            setTimeout(() => {
                                this.msg = null
                                this.$router.push('/base-trumpet-select')
                            }, 1000)
                        } else {
                            this.msg = res.data.msg
                            setTimeout(() => {
                                this.msg = null
                            }, 2000)
                        }
                    }).
                    catch(o => {
                        this.msg = '请求失败'
                        setTimeout(() => {
                            this.msg = null
                        }, 2000)
                    })
                }
            },
            onPwd () {
                if (this.config.system == 1) {
                    this.$emit('childPwd', 2)
                } else {
                    this.$emit('childPwd', 1)
                }
            }
        },
        created () {
            this.loginData = JSON.parse(sessionStorage.getItem('loginData'))
        }
    }
</script>

<style lang="scss" scoped>
    $color: #FF6C22; // 主体颜色
    // 横屏css
    .base-login-phone {
        min-height: 756px;
        overflow: hidden;
        transition: all 0.3s;
        .logo {
            width: 126px;
            height: 126px;
            margin: 45px auto 0;
            display: block;
        }
        .value {
            width: 100%;
            height: 120px;
            color: #fff;
            font-size: 39px;
            border: 0;
            border-radius: 18px;
            background: rgba(255, 255, 255, 0.2);
            padding: 0 45px;
            margin: 45px 0 30px;
            outline: none;
        }
        .val-box {
            width: 100%;
            height: 120px;
            color: #fff;
            border-radius: 18px;
            background: rgba(255, 255, 255, 0.2);
            display: flex;
            align-items: center;
            .phonecode {
                width: 477px;
                height: 48px;
                color: #fff;
                font-size: 39px;
                border: 0;
                border-right: 3px solid $color;
                border-radius: 18px 0 0 18px;
                background: transparent;
                padding: 0 45px;
                outline: none;
            }
            .code {
                flex: 1;
                color: $color;
                font-size: 36px;
                display: flex;
                justify-content: center;
            }
        }
        input::-webkit-input-placeholder{
            color:rgba(255, 255, 255, 0.5);
        }
        input::-moz-input-placeholder{
            color:rgba(255, 255, 255, 0.5);
        }
        input::-ms-input-placeholder{
            color:rgba(255, 255, 255, 0.5);
        }
        input::-o-input-placeholder{
            color:rgba(255, 255, 255, 0.5);
        }
        .btn-login {
            height: 120px;
            font-size: 39px;
            border-radius: 18px;
            background: $color;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 30px;
        }
        .footer {
            width: 100%;
            padding: 0 50px;
            position: absolute;
            left: 0;
            bottom: 59px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .item {
                width: 33%;
                height: 32px;
                color: $color;
                font-size: 33px;
                border-right: 2px solid rgba(255, 255, 255, 0.2);
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .item:last-child {
                border-right: 0;
            }
        }
    }
    // 竖屏css
    .loginphone-sp {
        min-height: 1374px;
        .logo {
            width: 229px;
            height: 229px;
            margin: 81px auto 0;
        }
        .value {
            height: 200px;
            font-size: 70px;
            border-radius: 32px;
            padding: 0 81px;
            margin: 81px 0 54px;
        }
        .val-box {
            height: 200px;
            border-radius: 32px;
            .phonecode {
                width: 867px;
                height: 87px;
                font-size: 70px;
                border-right: 5px solid $color;
                border-radius: 32px 0 0 32px;
                padding: 0 81px;
            }
            .code {
                font-size: 65px;
            }
        }
        .btn-login {
            height: 200px;
            font-size: 70px;
            border-radius: 32px;
            margin-top: 54px;
        }
        .footer {
            padding: 0 90px;
            bottom: 107px;
            .item {
                height: 58px;
                font-size: 60px;
                border-right: 3px solid rgba(255, 255, 255, 0.2);
            }
        }
    }
</style>